// extracted by mini-css-extract-plugin
module.exports = {"localOverrideLabel":"ThermostatLocalOverrideLabel_localOverrideLabel__1wDG5"};